import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextEditModalModule } from 'NewAngular/features/components/modals/text-edit-modal/text-edit-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class EditInWYSIWYGModalModule {
}
EditInWYSIWYGModalModule.ɵfac = function EditInWYSIWYGModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditInWYSIWYGModalModule)(); };
EditInWYSIWYGModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: EditInWYSIWYGModalModule });
EditInWYSIWYGModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule, TooltipModule, TextEditModalModule] });
